module.exports = __webpack_public_path__ + "static/redstamp-bd60061b35d784afb0733da06a8c7c8e.jpg";